// UI imports
import Menu from '../../../components/stateful/menu/Menu';
import PrivatePageLayout from '../../../layout/privatePageLayout/PrivatePageLayout';
import Table from '../../../components/stateful/table/Table';
import CustomButton from '../../../components/stateless/customButton/CustomButton';
import { useFilingController } from './FilingsController';
import CustomDialog from '../../../components/stateless/dialog/CustomDialog';
import FilingForm from './filingForm/FilingForm';

// css
import './Filings.scss';
import { useParams } from 'react-router-dom';

function Filings() {
    const { id: defaultFilingId } = useParams();

    const {
        // functions
        selectFilingType,
        selectFilingForm,
        closeFilingForm,
        // getFilings,
        toggleDialog,
        openFiling,
        // redux
        filings,
        filingTypes,
        fetchingFilings,
        // state
        selectedFilingType,
        selectedFiling,
        selectedFilingForms,
        selectedFilingForm,
        dialogOpen,
        columns,
        // props
        selectedFilingTypeTab,
        selectedFilingFormTab,
    } = useFilingController(defaultFilingId);

    // used to prevent requesting filingData when none is found

    const renderMenu = () => {
        return (
            <Menu
                menuItems={filingTypes}
                objectKey='filingFormTypeName'
                onClick={(event: any) => selectFilingType(event)}
                isCamelCaseItems
                selectedTab={selectedFilingTypeTab}
            />
        )
    }

    const renderSubMenu = () => {
        return (
            <Menu
                menuItems={selectedFilingForms}
                objectKey='filingFormName'
                onClick={selectFilingForm}
                vertical
                isCamelCaseItems
                selectedTab={selectedFilingFormTab}
            />
        )
    }

    const renderDetails = (data: any) => {
        // let docket = data.dataItem.docketNumberDto;
        return (
            <div className="filing-detail-panel">
                <div>
                    <div className='filing-detail-header'>
                        <b>Filing Details: {data.dataItem.filingName}</b>
                        <div>
                            <CustomButton
                                fillMode='solid'
                                icon="hyperlink-open"
                                themeColor="primary"
                                onClick={() => openFiling(filings.find(x => x.id === data.dataItem.id))}
                            >
                                Open Filing
                            </CustomButton>
                        </div>
                    </div>
                    <div className="filing-detail-card">
                        <div>
                            <b>Agency:</b> {data.dataItem.agencyName ?? "No Agency Name Found"}
                        </div>
                        <div>
                            <b>Title:</b> {data.dataItem.titleNumber ? data.dataItem.titleNumber + ": " : ""} {data.dataItem.titleName ?? "No Title Name Found"}
                        </div>
                        <div>
                            {/* <b>Docket:</b> {docket.yearPart ?? '' + "-" + docket.numberPart ?? ''} */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const renderFilings = () => {
        return (
            <>
                <Table
                    values={filings}
                    columns={columns}
                    tableName={selectedFilingType}
                    height='80vh'
                    details={(data) => renderDetails(data)}
                    onClickAdd={() => { openFiling() }}
                    isLoading={fetchingFilings}
                    onClickAddText='Create New Filing'
                />
            </>
        );
    }

    const renderDialog = () => {
        return (
            <CustomDialog open={dialogOpen} title={selectedFilingType} toggleDialog={toggleDialog} size="large" hideButtons>
                {selectedFilingForm ? (
                    <FilingForm
                        filing={selectedFiling}
                        closeFilingForm={closeFilingForm}
                        filingFormData={selectedFilingForm}
                        filingFormType={selectedFilingType}
                    />
                ) : null}
            </CustomDialog>
        )
    }

    return (
        <PrivatePageLayout>
            {renderDialog()}
            {renderMenu()}
            <div className='filing-page-body'>
                {renderSubMenu()}
                {renderFilings()}
            </div>
        </PrivatePageLayout>
    )
}

export default Filings